const validate = values => {
  const errors = {};

  if (!values.vehicle) {
    errors.vehicle = 'Requerido';
  }

  if (values.services && !values.services.length) {
    errors.services = 'Requerido';
  }

  const fields = ['vehicle', 'is_under_warranty', 'license_plate'];

  fields.forEach(field => {
    if (values.hasOwnProperty(field) && values[field] === undefined) {
      errors[field] = 'Requerido';
    }
  });

  const personalFields = ['name', 'lastname', 'email', 'cellphone', 'address'];

  if (values.personal_information) {
    errors.personal_information = {};

    personalFields.forEach(field => {
      if (!values.personal_information[field]) {
        errors.personal_information[field] = 'Requerido';
      }
    });
  }

  return errors;
};

export default validate;
